import React from 'react';
import TagManager from 'react-gtm-module';

import { useGoogleKeysProviderContext } from '@common/react/components/google/GoogleKeysProvider/GoogleKeysProvider';

const GoogleTagManager: React.FC<{ id?: string }> = (props) => {
	const {
		id = useGoogleKeysProviderContext()?.state?.tagManagerId,
	} = props;

	React.useEffect(() => {
		if (process.env.NODE_ENV === 'production' && id && id.trim() !== '') {
			TagManager.initialize({ gtmId: id });
		}
	}, [id]);

	return <></>;
};

export default GoogleTagManager;
